import { render, staticRenderFns } from "./brandManage.vue?vue&type=template&id=4861de31&scoped=true&"
import script from "./brandManage.vue?vue&type=script&lang=js&"
export * from "./brandManage.vue?vue&type=script&lang=js&"
import style0 from "./brandManage.vue?vue&type=style&index=0&id=4861de31&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861de31",
  null
  
)

export default component.exports